import { createApi } from "@reduxjs/toolkit/query/react";

// Типы для параметров запроса
export interface CharityControlParams {
    page?: number;
    per_page?: number;
    show_only_low_balance?: boolean;
    show_only_negative_balance?: boolean;
    search?: string;
    sponsor_id?: number;
}

// Типы для данных пользователя
export interface CharityControlUser {
    id: number;
    photo: string;
    ref_link: string;
    full_name: string;
    rank: number;
    created_at: string;
    charity_current: number;
    charity_total: number;
    charity_earned_total: number;
    inviter_name: string;
    is_blocked: boolean;
    balances: {
        main_wallet: number;
        usdt_wallet: number;
        main_future_charity: number;
        usdt_future_charity: number;
        total: number;
    };
}

// Типы для метаданных пагинации
export interface CharityControlMeta {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

// Типы для сводной статистики
export interface CharityControlSummary {
    total_users: number;
    with_low_balance: number;
    with_negative_balance: number;
}

// Типы для ответа API
export interface CharityControlResponse {
    success: boolean;
    data: CharityControlUser[];
    meta: CharityControlMeta;
    summary: CharityControlSummary;
}

// Теги для кэширования
export const charityControlTags = [
    "charityControl",
    "charityControlUsers",
] as const;

// Эндпоинты
export const charityControlEndpoints = {
    getCharityControlUsers: {
        query: (params: CharityControlParams = {}) => ({
            url: "/admin/charity-control/all",
            params,
        }),
        providesTags: [charityControlTags[1]],
    },
};

// Создание API (будет интегрировано в главный API файл)
export const charityControlApi = createApi({
    reducerPath: "charityControlApi",
    baseQuery: () => ({ data: null }), // Будет переопределено в главном API
    tagTypes: charityControlTags,
    endpoints: (builder) => ({
        getCharityControlUsers: builder.query<
            CharityControlResponse,
            CharityControlParams
        >({
            query: charityControlEndpoints.getCharityControlUsers.query,
            providesTags: [charityControlTags[1]],
        }),
    }),
});

// Экспорт хуков
export const { useGetCharityControlUsersQuery } = charityControlApi;
